<template>
  <div class="addOnlineContainer">
    <section>
      <h2>
        杉泰发薪表
        <a @click="downloadExample">【 示例excel 】</a>
      </h2>
      <ul>
        <li>
          <label><i>*</i>表格日期：</label>
          <a-date-picker @change="changeDate" v-model="date" />
        </li>
        <li>
          <label><i>*</i>表格：</label>
          <input type="file" @change="changeExcelVal" />
        </li>
      </ul>
      <a-button type="primary" @click="submitUpload">{{
        upTxtAdvance
      }}</a-button>
    </section>
    <div class="hint">
      <h3>注意事项</h3>
      <span>1、必须为.xls或.xlsx结尾的excel；</span>
      <span>2、表格中不得有空行空列，无数据填0；</span>
      <span>3、表格中所有数据均为文本格式；</span>
      <span>4、表格日期指甲方给表日期,首次上传新增，重复上传更新。</span>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      excelFile: "",
      downloadTxt: "下载",
      upTxt: "上传",
      advanceCashierFile: "",
      upTxtAdvance: "上传",
      batchAdvanceFile: "",
      upTxtBatchAdvance: "上传",
      salary_date: "",
      date: null
    };
  },
  methods: {
    changeDate(date, dateString) {
      this.salary_date = dateString;
    },
    changeExcelVal(e) {
      this.excelFile = e.target.files[0];
    },
    downloadExample() {
      window.location.href =
        this.httpsBasic.url +
        this.httpsBasic.user +
        "St_user/uploadSalaryTpl?token=" +
        window.localStorage.getItem("xnwfPcToken");
    },
    submitUpload() {
      let _this = this;
      if (this.excelFile != "") {
        this.$confirm({
          title: "是否确认该日期表格无问题上传",
          okText: "确认",
          okType: "danger",
          cancelText: "取消",
          onOk() {
            _this.upExcel();
          },
          onCancel() {
            // console.log("Cancel");
          }
        });
      } else {
        this.$message.warning("请选择规定格式的Excel上传");
      }
    },
    upExcel() {
      this.upTxt = "上传中...";
      let formData = new FormData();
      formData.append("excel", this.excelFile);
      formData.append("salary_date", this.salary_date);
      formData.append("token", window.localStorage.getItem("xnwfPcToken"));
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      let url = this.httpsBasic.url + this.httpsBasic.user + "St_user/upload";
      axios
        .post(url, formData, config)
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success("上传成功");
            this.salary_date = "";
            this.excel = "";
            this.date = null;
            this.$emit("hideInAdd", false);
          } else {
            this.$message.warning(res.data.message);
          }
          this.upTxt = "上传";
        })
        .catch(err => {
          this.$message.error(err);
        });
      this.upTxt = "上传";
    }
  }
};
</script>
<style lang="less" scoped>
.addOnlineContainer {
  padding: 50px 4%;
  position: relative;
  ul {
    margin-top: 30px;
  }
  i {
    display: inline-block;
    color: red;
    font-style: normal;
    margin-right: 4px;
  }
  h2 {
    font-weight: normal;
    a {
      font-size: 14px;
      display: inline-block;
      margin-left: 20px;
    }

    > span {
      font-size: 14px;
    }
  }
  input {
    margin: 20px 30px;
  }
  button {
    display: block;
    margin: 0 30px 50px 70px;
  }
  .hint {
    background: rgba(230, 162, 60, 0.1);
    padding: 10px 20px;
    margin: 10px 30px 20px;
    width: 400px;
    position: absolute;
    right: 0;
    top: 10px;
    z-index: 1;
    h3 {
      color: #666;
      font-size: 16px;
      font-weight: normal;
    }
    span {
      display: block;
      font-size: 14px;
      line-height: 24px;
      color: #666;
    }
  }
}
</style>
